export const linesSection = () => {
  if (document.querySelector('.lines')) {
    const images = document.querySelectorAll('.lines__images img')
    const items = document.querySelectorAll('.lines__item')
    const itemsTop = document.querySelectorAll('.lines__item-top')
    const itemsBottom= document.querySelectorAll('.lines__item-bottom')

    images[0].classList.add('active')
    items[0].classList.add('active')
    window.addEventListener('load', () => {
      itemsBottom[0].style.maxHeight = `${itemsBottom[0].scrollHeight}px`
    })

    itemsTop.forEach(function (top, index) {
      top.addEventListener('click', () => {
        items.forEach((item) => item.classList.remove('active'))
        items[index].classList.add('active')

        images.forEach((image) => image.classList.remove('active'))
        images[index].classList.add('active')

        itemsBottom.forEach(function (bottom) {
          bottom.style.maxHeight = '0px'
        })
        if (window.innerWidth <= 999) {
          itemsBottom[index].style.maxHeight = `${itemsBottom[index].scrollHeight+20}px`
        } else {
          itemsBottom[index].style.maxHeight = `${itemsBottom[index].scrollHeight}px`
        }

        setTimeout(() => {
          if (window.ScrollTrigger) {
            ScrollTrigger.refresh()
          }
          if (window.lenis && window.lenis.resize) {
            window.lenis.resize()
          }
        }, 450)

      })
    })

  }
}